// import { AnyAction, ThunkAction, configureStore } from '@reduxjs/toolkit';
// import rootReducer from './rootReducer';
import {
  persistStore,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
// import thunk from 'redux-thunk';

// export type AppDispatch = typeof store.dispatch;

// export type RootState = ReturnType<typeof store.getState>;

// export type AppThunk = ThunkAction<void, RootState, unknown, AnyAction>;

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: [thunk],
//   // Additional configuration options if needed
// });
// const persistor = persistStore(store);
// export { store, persistor };

import { configureStore } from '@reduxjs/toolkit';
import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
// ...

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);
export { store, persistor };

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;
